import { useEffect, useState } from 'react'
import { useAuthenticationStatus, useUserId } from '@nhost/nextjs'
import { useRouter } from 'next/router'
import dayjs from 'dayjs'

import { Button, Text } from 'components/atomic'
import { useAddUserFlagsMutation, useUserMetadataQuery } from 'generated/graphql'

export default function FounderBuild() {
  const router = useRouter()
  const { isAuthenticated } = useAuthenticationStatus()
  const userId = useUserId()
  const { data: userData } = useUserMetadataQuery()
  const [addFounderTesting, { loading: addFounderTestingLoading }] = useAddUserFlagsMutation()

  const [isFounderTestingOpted, setIsFounderTestingOpted] = useState(false)

  useEffect(() => {
    const user = userData?.users_metadata[0]
    if (!user) return

    if (user.flags?.founderTestingOpted === 1) {
      setIsFounderTestingOpted(true)
    }
  }, [userData?.users_metadata])

  const handleAddFounderTesting = async () => {
    if (isAuthenticated) {
      try {
        await addFounderTesting({
          variables: {
            userId,
            flagsValue: {
              founderTestingOpted: 1,
              founderTestingOptDate: dayjs().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            },
          },
        })
        setIsFounderTestingOpted(true)
      } catch (error) {
        console.error('addFounderTesting error:', error)
      }
    } else {
      router.push(`/login?redirect=${encodeURIComponent('/founder-profile')}`)
    }
  }

  return (
    <div className="border-2 border-primary/20 p-8">
      <div className="mb-10 text-base font-medium text-white/70">
        <div className="mb-5 text-xl font-semibold uppercase leading-6 tracking-tight text-white">Founder Testing</div>
        Get hands-on with the latest development builds of DEADROP. Join our Founder Testing sessions in the Midnight
        Society Discord. Opt-in below to be eligible.
        <br />
        <br />
        DEADROP is in active development, features and decisions may change based on internal tests and your feedback.
        Expect crashes, bugs, unpolished features, and exploits.
        <br />
        <br />
        Disclaimer: You must opt in within 24 hours of the next Founder Testing event in order to get access on time. If
        you do not opt-in in time, you will gain access for the next founder test. More information can be{' '}
        <a className="underline hover:text-secondary" href="http://discord.gg/midnight-society">
          found on discord
        </a>
        .
      </div>

      <div className="flex flex-row gap-4 items-center">
        <Button
          variant="primary"
          onClick={handleAddFounderTesting}
          disabled={addFounderTestingLoading || isFounderTestingOpted}
          state={addFounderTestingLoading || isFounderTestingOpted ? 'disabled' : ''}
        >
          <Text variant="button" tag="span" className="sm:whitespace-nowrap">
            {isFounderTestingOpted ? "You're in!" : 'Opt-in'}
          </Text>
        </Button>
        {isFounderTestingOpted && (
          <div className="text-secondary text-sm uppercase">
            Setup instructions will be emailed approximately 24 hours before the next founder test
          </div>
        )}
      </div>
    </div>
  )
}
